import { assertNonNegativeInteger } from '../shared/invariants';

export const BattleEventType = {
  BATTLE_PHASE_CHANGED: 'BATTLE_PHASE_CHANGED',
  CHARACTER_STATE_CHANGED: 'CHARACTER_STATE_CHANGED',
  BATTLE_RESET: 'BATTLE_RESET',
  ATTACK_STARTED: 'ATTACK_STARTED',
  HIT: 'HIT',
  GUARD: 'GUARD',
  COUNTER: 'COUNTER',
  DAMAGE_APPLIED: 'DAMAGE_APPLIED',
  GAUGE_CHANGED: 'GAUGE_CHANGED',
  COMBO_STARTED: 'COMBO_STARTED',
  COMBO_UPDATED: 'COMBO_UPDATED',
  COMBO_ENDED: 'COMBO_ENDED',
  KNOCKDOWN: 'KNOCKDOWN',
  WAKE_UP: 'WAKE_UP',
  EFFECT_APPLIED: 'EFFECT_APPLIED',
  EFFECT_EXPIRED: 'EFFECT_EXPIRED',
  KO: 'KO',
  DRAW: 'DRAW',
  TIME_UP: 'TIME_UP',
  SUPER_CINEMATIC_STARTED: 'SUPER_CINEMATIC_STARTED',
} as const;

export type BattleEventType = (typeof BattleEventType)[keyof typeof BattleEventType];
export type BattleEventValue = string | number | boolean | null;

export interface BattleEvent {
  readonly logicalFrame: number;
  readonly sequence: number;
  readonly type: BattleEventType;
  readonly payload: Readonly<Record<string, BattleEventValue>>;
}

export const createBattleEvent = (
  logicalFrame: number,
  sequence: number,
  type: BattleEventType,
  payload: Readonly<Record<string, BattleEventValue>>,
): BattleEvent => {
  assertNonNegativeInteger(logicalFrame, 'logicalFrame');
  assertNonNegativeInteger(sequence, 'sequence');
  return Object.freeze({ logicalFrame, sequence, type, payload: Object.freeze({ ...payload }) });
};
